import { distSq } from "./distsq";
export var dist = function dist(a, b) {
  return Math.sqrt(distSq(a, b));
};